exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* stylelint-disable */\n\n/* ==========================================================================\n   Icon Button\n   ========================================================================== */\n.icon-button {\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  color: #fff;\n  cursor: pointer; }\n  .icon-button:nth-child(n+2) {\n    margin-left: 10px; }\n  .icon-button:focus {\n    box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.12), 0 2px 5px 0 rgba(0, 0, 0, 0.16);\n    outline: none; }\n\n/* Disabled state\n   ========================================================================== */\n.icon-button--disabled {\n  opacity: 0.3; }\n\n/* Shapes\n   ========================================================================== */\n.icon-button--circle {\n  border-radius: 50%; }\n\n.icon-button--square {\n  border-radius: 3px; }\n\n/* Sizes\n   ========================================================================== */\n.icon-button--small {\n  width: 30px;\n  height: 30px; }\n\n.icon-button--medium {\n  width: 36px;\n  height: 36px; }\n\n.icon-button--large {\n  width: 40px;\n  height: 40px; }\n\n.icon-button--x-large {\n  width: 50px;\n  height: 50px; }\n\n.icon-button--xx-large {\n  width: 60px;\n  height: 60px; }\n\n/* Colors\n   ========================================================================== */\n.icon-button--neutral {\n  color: #858484;\n  background-color: transparent; }\n  .icon-button--neutral:hover {\n    background-color: #f2f2f2; }\n  .icon-button--neutral:active {\n    background-color: #f8f8f8; }\n\n.icon-button--primary {\n  background-color: #f57b45; }\n  .icon-button--primary:hover {\n    background-color: #d45e2a; }\n  .icon-button--primary:active {\n    background-color: #ef9a78; }\n\n.icon-button--secondary {\n  background-color: #25b8d2; }\n  .icon-button--secondary:hover {\n    background-color: #1797ae; }\n  .icon-button--secondary:active {\n    background-color: #57d0dd; }\n\n.icon-button--success {\n  background-color: #96cb4c; }\n  .icon-button--success:hover {\n    background-color: #81a03c; }\n  .icon-button--success:active {\n    background-color: #b7dd7a; }\n\n.icon-button--warning {\n  background-color: #eca03e; }\n  .icon-button--warning:hover {\n    background-color: #c2802a; }\n  .icon-button--warning:active {\n    background-color: #fbc75c; }\n", ""]);

// exports
exports.locals = {
	"color-groups": "base | colors | primary | semantic | chart",
	"colors-white": "#fff",
	"colors-red": "#f54545",
	"colors-green": "#6acb4c",
	"colors-body-color": "#363636",
	"colors-grey-90": "#444",
	"colors-grey-80": "#666",
	"colors-grey-70": "#858484",
	"colors-grey-60": "#a4a4a4",
	"colors-grey-50": "#c2c2c2",
	"colors-grey-40": "#ddd",
	"colors-grey-30": "#ececec",
	"colors-grey-20": "#f2f2f2",
	"colors-grey-10": "#f8f8f8",
	"colors-black": "#000",
	"base-brown-100": "#343230",
	"base-brown-80": "#474340",
	"base-brown-60": "#61554c",
	"base-brown-40": "#998673",
	"base-brown-20": "#c1aa95",
	"base-earth-100": "#bbb6af",
	"base-earth-80": "#c7c1b8",
	"base-earth-60": "#d7cebf",
	"base-earth-40": "#eae4db",
	"base-earth-20": "#e9e7db",
	"base-earth-10": "#f7f5eb",
	"primary-romantic-purple-base": "#834ba2",
	"primary-romantic-purple-dark": "#5a3770",
	"primary-romantic-purple-light": "#ab83c4",
	"primary-sky-blue-base": "#25b8d2",
	"primary-sky-blue-dark": "#1797ae",
	"primary-sky-blue-light": "#57d0dd",
	"primary-mint-base": "#3fc798",
	"primary-mint-dark": "#2cab7f",
	"primary-mint-light": "#79dbb5",
	"primary-grassy-base": "#96cb4c",
	"primary-grassy-dark": "#81a03c",
	"primary-grassy-light": "#b7dd7a",
	"primary-desert-sunset-base": "#eca03e",
	"primary-desert-sunset-dark": "#c2802a",
	"primary-desert-sunset-light": "#fbc75c",
	"primary-salmon-base": "#f57b45",
	"primary-salmon-dark": "#d45e2a",
	"primary-salmon-light": "#ef9a78",
	"semantic-color-primary": "#f57b45",
	"semantic-color-primary-hovered": "#d45e2a",
	"semantic-color-primary-active": "#ef9a78",
	"semantic-color-secondary": "#25b8d2",
	"semantic-color-secondary-hovered": "#1797ae",
	"semantic-color-secondary-active": "#57d0dd",
	"semantic-color-light": "#fff",
	"semantic-color-light-hovered": "#fff",
	"semantic-color-light-active": "#fff",
	"semantic-color-dark": "#f8f8f8",
	"semantic-color-dark-hovered": "#f2f2f2",
	"semantic-color-dark-active": "#f8f8f8",
	"semantic-color-error": "#f54545",
	"semantic-color-success": "#6acb4c",
	"semantic-color-warning": "#eca03e",
	"semantic-color-instruction": "#25b8d2",
	"semantic-color-info": "#834ba2",
	"semantic-color-hint": "#c2c2c2",
	"chart-first": "#25b8d2",
	"chart-second": "#f57b45",
	"chart-third": "#96cb4c",
	"chart-fourth": "#eca03e",
	"chart-fifth": "#3fc798",
	"chart-sixth": "#ab83c4",
	"chart-seventh": "#c1aa95",
	"chart-eighth": "#c2c2c2"
};